import type { FreedrawData } from './types';

export function makeDefault(): FreedrawData {
  return {
    points: [],
    initialSize: { width: 1, height: 1 },
    strokeColor: '#2D3134',
    strokeWidth: 2,
  };
}
